export const environment = {
	production: false,
	region: 'ap-southeast-2',
	endpoint: 'https://staging.api.reali.au',
	wsEndPoint: 'wss://staging.api.reali.au',
	logLevel: 'debug',
	appName: 'REALI',
	buildId: process.env.NG_APP_BUILD_ID || 'local',
	defaultCollectionLimit: 10,
	enableSentry: true,
	defaultTestEmailAddress: "",
version: "staging_1628",
	baseDomain: 'staging.reali.au',
	readApiToken: "39cafcf2862b2e6627657b726f76d0371fd0e690",
	analyticsTrackingCode: '',
	GTMTrackingId: '',
	defaultSsoPool: '',
	defaultSsoDomain: '',
	stripePublishedKey: 'pk_test_51S8auF29VCwtBY02w429cXM9to5yZ0wQPhxR9WvG5Su9gpxuRSvg3Whfd9E2FFd3odYjEtmI8J0flHzCyROqDId400gcXdIdnl',
	staticAssets: {
		bucket: 'static.reali.au',
		cdnUrl: 'https://static.reali.au',
	},
};
